export default function Statistics() {
  return (
    <section className="py-24 bg-gradient-to-br from-white via-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-orange-400 to-pink-500 rounded-3xl p-12 relative overflow-hidden group cursor-pointer hover:scale-105 transition-transform duration-300">
            <div className="absolute top-8 right-8 w-12 h-12 bg-white rounded-full flex items-center justify-center cursor-pointer">
              <i className="ri-arrow-right-up-line text-orange-500 text-xl"></i>
            </div>
            <div className="relative z-10">
              <div className="text-6xl font-serif font-bold text-white mb-4">3 Key Verticals</div>
              <h3 className="text-2xl font-bold text-white mb-4">Specialized Market Focus</h3>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <i className="ri-graduation-cap-line text-white text-xl"></i>
                  <p className="text-white/90 font-medium">Education</p>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-service-line text-white text-xl"></i>
                  <p className="text-white/90 font-medium">Managed Services</p>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-government-line text-white text-xl"></i>
                  <p className="text-white/90 font-medium">Government</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-teal-400 to-emerald-500 rounded-3xl p-12 relative overflow-hidden group cursor-pointer hover:scale-105 transition-transform duration-300">
            <div className="absolute top-8 right-8 w-12 h-12 bg-white rounded-full flex items-center justify-center cursor-pointer">
              <i className="ri-arrow-right-up-line text-teal-600 text-xl"></i>
            </div>
            <div className="relative z-10">
              <div className="text-7xl font-serif font-bold text-white mb-4">95%</div>
              <h3 className="text-2xl font-bold text-white mb-2">Vendor Satisfaction Rate</h3>
              <p className="text-white/90 italic">Consistently exceeding expectations</p>
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="text-4xl font-bold text-gray-900 mb-2">50+</div>
            <p className="text-gray-600">Active Vendor Partners</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gray-900 mb-2">30+</div>
            <p className="text-gray-600">Markets Covered</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gray-900 mb-2">10+</div>
            <p className="text-gray-600">Years Experience</p>
          </div>
        </div>
      </div>
    </section>
  );
}